import { Button, AspectRatio, Center, Flex, Text } from '@chakra-ui/react';
import NextImage from 'next/image';
import NextLink from 'next/link';

import IcMicrophone from '@/assets/icons/ic-microphone.svg';
import ReadyToTransformBgImage from '@/assets/images/publishers/bg-ready-transform.png';

export const ReadyToTransform = () => {
  return (
    <Center mt={10} position="relative">
      <AspectRatio objectFit="cover" h={{ base: '275px', md: '285px', lg: '511px' }} w="full" ratio={1445 / 510}>
        <NextImage
          objectPosition="center"
          quality={90}
          layout="fill"
          priority={true}
          src={ReadyToTransformBgImage}
          alt="Hero cover"
        />
      </AspectRatio>
      <Flex
        textAlign="center"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        w="full"
        color="white"
        px={5}
      >
        <Text fontWeight="bold" fontFamily="heading" fontSize={{ base: '2xl', md: '4xl', lg: '5xl' }}>
          Ready to Transform
          <br />
          Your Conference?
        </Text>
        <Text mt={{ base: 4, lg: 8 }} fontSize={{ base: 'lg', lg: 'xl' }}>
          Join the scientific societies already revolutionizing their reach and impact with professional conference
          recording.
        </Text>
        <NextLink href="/contact-us/conferences">
          <Button size={{ base: 'sm', lg: 'lg' }} leftIcon={<IcMicrophone width="24px" />} mt={5}>
            Start Your Consultations
          </Button>
        </NextLink>
      </Flex>
    </Center>
  );
};
